<template>
	<AppDialog closeTop="-30" closeRight="-2" dialogName="MeetOurTeamDialog" width="790" disable-max-width>
		<div class="meet-content-container width-100 display-flex flex-row">
			<div class="display-flex flex-column flex-justify-center left-side-content">
				<div class="welcome-text mb-2">Welcome to Ply 👋</div>
				<div class="meet-text mb-7">Meet with our team</div>
				<h3 class="reg">
					Whether you want to get a 1:1 demo of Ply, need help building, or just want to know how other teams are using Ply - we’ll help you
					achieve your goals.
				</h3>
				<div class="footer-container display-flex flex-row flex-align-center">
					<a
						href=""
						onclick="Calendly.initPopupWidget({url: 'https://calendly.com/d/2d7-m5y-77k/talk-to-the-ply-team?hide_gdpr_banner=1'});return false;"
					>
						<AnemicButton href="" @click="contactUs" tile class="yes-button">Pick a time</AnemicButton>
					</a>
					<AnemicButton @click="close" tile class="no-button ml-3">No thanks</AnemicButton>
				</div>
			</div>
			<v-img :src="MeetOurTeamImage" width="270" />
		</div>
	</AppDialog>
</template>

<script>
import AppDialog from '../AppDialog/AppDialog';
import AppDialogManagerService from '../AppDialogManager/app-dialog-manager-service';
import MeetOurTeamImage from '@/assets/img/meet-our-team.png';

export default {
	name: 'MeetOurTeamDialog',
	components: { AppDialog },
	props: {},
	methods: {
		close() {
			AppDialogManagerService.closeCurrentDialog();
		},
		contactUs() {
			this.close();
		},
	},
	computed: {},
	data() {
		return { MeetOurTeamImage };
	},
};
</script>

<style scoped lang="scss">
.meet-content-container {
	height: 380px;
	border-radius: 10px;
	background: var(--white);
	letter-spacing: 0px;
	color: var(--primary-font-color);
	box-shadow: 0px 3px 6px #00000029;
}

.left-side-content {
	padding: 0px 90px 0px 34px;
}
.welcome-text {
	font-size: 14px;
	font-weight: medium;
}
.meet-text {
	font-size: 26px;
	font-weight: bold;
}
.footer-container {
	margin-top: 68px;
}

.footer-button {
	padding: 0px !important;
	width: 140px !important;
	height: 40px !important;
	font-size: 14px !important;
	border-radius: 8px !important;
	font-weight: normal !important;
	letter-spacing: 0px !important;
}
.no-button {
	@extend .footer-button;
	background: var(--white) !important;
	color: var(--bold-border-color) !important;
	border: 1px solid var(--bold-border-color) !important;
}
.yes-button {
	@extend .footer-button;
	color: var(--white) !important;
	background: var(--bold-border-color) !important;
}
a {
	text-decoration: none !important;
}
</style>
